import { render, staticRenderFns } from "./CoozzyArrowDownIcon.vue?vue&type=template&id=0d6e3003&scoped=true"
import script from "./CoozzyArrowDownIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyArrowDownIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyArrowDownIcon.vue?vue&type=style&index=0&id=0d6e3003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e3003",
  null
  
)

export default component.exports